const authRoles = {
  admin: ["ADMIN"],
  is_staff: ["Hantoo", "Crescendo", "DTT", "DB", "temp", "test"],
};

export default authRoles;
